import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { IconButton, IconButtonProps } from 'shared/mui/IconButtons';

export type PasswordVisibilityIconButtonProps = Omit<IconButtonProps, 'icon'> & {
  isVisible?: boolean;
};

export const PasswordVisibilityIconButton: React.FC<PasswordVisibilityIconButtonProps> = ({
  isVisible,
  sx = { color: 'secondary.main' },
  ...props
}) => (
  <IconButton sx={sx} {...props}>
    {isVisible ? <VisibilityOffIcon /> : <VisibilityIcon />}
  </IconButton>
);
